import { render, staticRenderFns } from "./EmployeeJourneyAssignmentDetails.vue?vue&type=template&id=801645e4&scoped=true&"
import script from "./EmployeeJourneyAssignmentDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeeJourneyAssignmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeJourneyAssignmentDetails.vue?vue&type=style&index=0&id=801645e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801645e4",
  null
  
)

export default component.exports